import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import SegmentedControl from '../components/shared/SegmentedControl.svelte';
import Card from '../components/shared/Card.svelte';
import Button from '../components/shared/Button.svelte';
import Modal from '../components/shared/Modal.svelte';
import { getSettings, updateSettings } from '../lib/stores/settings.svelte.ts';
import { resetAppState } from '../lib/stores/appState.svelte.ts';
import { navigate } from '../lib/router.svelte.ts';
import { db } from '../lib/db';
import { showToast } from '../components/shared/Toast.svelte';

var root_1 = $.from_html(`<div class="menu-item svelte-1gekbevn6ty0e">👶 Manage children</div>`);
var root_3 = $.from_html(`<p style="margin-bottom:16px;color:var(--muted-fg);font-size:14px;">This will permanently delete all sessions, storage, health data, reminders, all children, and app settings. This cannot be undone.</p> <div style="display:flex;gap:10px;"><!> <!></div>`, 1);
var root = $.from_html(`<!> <div class="settings-page svelte-1gekbevn6ty0e"><div class="settings-section svelte-1gekbevn6ty0e"><h3 class="svelte-1gekbevn6ty0e">Appearance</h3> <!></div> <div class="settings-section svelte-1gekbevn6ty0e"><h3 class="svelte-1gekbevn6ty0e">Units</h3> <!></div> <div class="settings-section svelte-1gekbevn6ty0e"><!></div> <div class="settings-section svelte-1gekbevn6ty0e"><!></div></div> <!>`, 1);

function Settings($$anchor, $$props) {
	$.push($$props, true);

	const settings = $.derived(getSettings);
	let showClearConfirm = $.state(false);

	const themeOptions = [
		{ value: 'light', label: 'Light' },
		{ value: 'dark', label: 'Dark' },
		{ value: 'system', label: 'System' }
	];

	const unitOptions = [
		{ value: 'metric', label: 'mL / g' },
		{ value: 'imperial', label: 'oz / lb' }
	];

	async function handleClearData() {
		try {
			await db.sessions.clear();
			await db.storageEntries.clear();
			await db.diapers.clear();
			await db.weights.clear();
			await db.reminders.clear();
			await db.activeTimer.clear();
			await db.children.clear();
			await db.settings.clear();
			await resetAppState();

			// Navigate to root and reload to reset all in-memory store state
			window.location.href = '/';
		} catch(e) {
			showToast('Failed to clear data. Please try again.', 'error');
		}
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Settings', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var div_1 = $.child(div);
	var node_1 = $.sibling($.child(div_1), 2);

	SegmentedControl(node_1, {
		get options() {
			return themeOptions;
		},

		get selected() {
			return $.get(settings).theme;
		},
		onchange: (v) => updateSettings({ theme: v })
	});

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_2 = $.sibling($.child(div_2), 2);

	SegmentedControl(node_2, {
		get options() {
			return unitOptions;
		},

		get selected() {
			return $.get(settings).units;
		},
		onchange: (v) => updateSettings({ units: v })
	});

	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var node_3 = $.child(div_3);

	Card(node_3, {
		onclick: () => navigate('/more/children'),
		children: ($$anchor, $$slotProps) => {
			var div_4 = root_1();

			$.append($$anchor, div_4);
		},
		$$slots: { default: true }
	});

	$.reset(div_3);

	var div_5 = $.sibling(div_3, 2);
	var node_4 = $.child(div_5);

	Button(node_4, {
		variant: 'danger',
		fullWidth: true,
		onclick: () => $.set(showClearConfirm, true),
		children: ($$anchor, $$slotProps) => {
			$.next();

			var text = $.text('Clear All Data');

			$.append($$anchor, text);
		},
		$$slots: { default: true }
	});

	$.reset(div_5);
	$.reset(div);

	var node_5 = $.sibling(div, 2);

	Modal(node_5, {
		get open() {
			return $.get(showClearConfirm);
		},
		onclose: () => $.set(showClearConfirm, false),
		title: 'Clear all data?',
		children: ($$anchor, $$slotProps) => {
			var fragment_1 = root_3();
			var div_6 = $.sibling($.first_child(fragment_1), 2);
			var node_6 = $.child(div_6);

			Button(node_6, {
				variant: 'secondary',
				fullWidth: true,
				onclick: () => $.set(showClearConfirm, false),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Cancel');

					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});

			var node_7 = $.sibling(node_6, 2);

			Button(node_7, {
				variant: 'danger',
				fullWidth: true,
				onclick: handleClearData,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_2 = $.text('Clear');

					$.append($$anchor, text_2);
				},
				$$slots: { default: true }
			});

			$.reset(div_6);
			$.append($$anchor, fragment_1);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Settings = $.hmr(Settings);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1gekbevn6ty0e');
		Settings[$.HMR].update(module.default);
	});
}

export default Settings;
import "bun-svelte:Settings.svelte-1v5xbv5z4i38f-style.css";